import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const { t, i18n } = useTranslation('home');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language === 'zh' ? '中文' : 'English');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLanguageChange = (lang: string, displayName: string) => {
    i18n.changeLanguage(lang);
    setCurrentLang(displayName);
    setIsLangDropdownOpen(false);
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/0bc1a2c5b0dc90360880a6e9e7b2e34d/eb03fcf9253e72dce7fdf93dd3957ada.png" 
                alt="安码士科技" 
                className="h-12"
              />
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              {t('navbar.home')}
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              {t('navbar.products')}
            </button>
            <button
              onClick={() => scrollToSection('cases')}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              {t('navbar.cases')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              {t('navbar.about')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              {t('navbar.contact')}
            </button>
            
            {/* Language Selector */}
            <div className="relative">
              <button
                onClick={() => setIsLangDropdownOpen(!isLangDropdownOpen)}
                className={`text-sm font-medium flex items-center space-x-1 transition-colors duration-200 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                <span>{currentLang}</span>
                <i className="ri-arrow-down-s-line"></i>
              </button>
              {isLangDropdownOpen && (
                <div className="absolute right-0 mt-2 w-32 bg-white rounded-lg shadow-lg py-2">
                  <button
                    onClick={() => handleLanguageChange('zh', '中文')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap"
                  >
                    中文
                  </button>
                  <button
                    onClick={() => handleLanguageChange('en', 'English')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap"
                  >
                    English
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
